import {Injectable} from '@angular/core';
import {MatNestedTreeNode, MatTreeFlattener} from '@angular/material';
import {ICommoditiesFlatNode} from '../pages/shared/types/commodities.type';
import {SelectionModel} from '@angular/cdk/collections';

@Injectable()
export class TreeService {
    private _transformer = undefined;

    constructor() {}

    getTreeFlattener() {
        return new MatTreeFlattener(
            this.transformer, (node: MatNestedTreeNode<any>) => node.level, node => node.expandable, node => node.children);
    }

    hasChild = (_: number, node: ICommoditiesFlatNode) => node.expandable;

    set transformer(cb: (node: any, level: number) => any) {
        this._transformer = cb;
    }

    get transformer() {
        return this._transformer;
    }

    getFirstParent(treeControl, node) {
        let insideNode = node;
        let parentNode = {};

        for (let i = treeControl.getLevel(insideNode); i > 0; i--) {
            parentNode = insideNode;
            insideNode = this.getTreeNodeParent(treeControl, parentNode);
        }
        const {item_type, code} = insideNode;
        return insideNode;
    }

    /**
     * Iterate over each node in reverse order and return the first node that has a lower level than the passed node.
     */
    getTreeNodeParent(treeControl, node) {
        const currentLevel = treeControl.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        const startIndex = treeControl.dataNodes.indexOf(node) - 1;
        for (let i = startIndex; i >= 0; i--) {
            const currentNode = treeControl.dataNodes[i];

            if (treeControl.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
    }

    getSelectedParent(treeControl, node) {
        let insideNode = node;
        let parentNode = {};

        for (let i = treeControl.getLevel(insideNode); i > 0; i--) {
            parentNode = insideNode;
            insideNode = this.getTreeNodeParent(treeControl, parentNode);
            if (insideNode.isSelected) {
                return insideNode;
            }
        }
        return undefined;
    }


    /** Whether part of the descendants are selected */
    descendantsPartiallySelected(treeControl, node, checklistSelection: SelectionModel<any>): boolean {
        try {
            const descendants = treeControl.getDescendants(node);
            const result = descendants.some(child => checklistSelection.isSelected(child));
            return result && (
                !this.descendantsAllSelected(treeControl, node, checklistSelection) ||
                (
                    descendants.length === 1 &&
                    (descendants[0] as any).isSelected &&
                    !this.getSelectedParent(treeControl, node)

                )
            );
        } catch (e) {
        }
    }

    /** Whether all the descendants of the node are selected */
    descendantsAllSelected(treeControl, node, checklistSelection: SelectionModel<any>): boolean {
        try {
            const descendants = treeControl.getDescendants(node);
            return descendants.every(child => checklistSelection.isSelected(child));
        } catch (e) {
        }
    }
}
